import { makeStyles } from "@material-ui/core/styles";

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Form, Input, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Pagination from "@material-ui/lab/Pagination";
import getStringsBasedLang from "../../strings/get_strings";
import moment from "moment-jalaali";
import { PER_PAGE } from "../../utils";
import { ErrorMessage } from "../error_handler/message_handler";
import Layout from "../layout/layout";
import { Container } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { setIsScan } from "../../redux/action/general_action";
import CustomGauge from "../../modules/custom_gauge/custom_gauge";
import { createData } from "../../api/http-service";
import UseErrorHandling from "../../hook/UseErrorHandling";

const lang = localStorage.getItem("lang");
const useStyles = makeStyles({
  root: {
    "& .MuiPaginationItem-page.Mui-selected": {
      backgroundColor: "#43c9c7",
      color: "white",
    },
    "& .MuiPaginationItem-root": {
      outline: 0,
      fontFamily: `${
        !lang || lang === "en"
          ? "englishIranSans !important"
          : "Vazir !important"
      }`,
    },
  },
  table: {
    minWidth: 650,
    marginTop: "20px",
    fontFamily: `IRANSansWithFarsiNumerals !important`,
  },
  tableCellHead: {
    color: "#07465d",
    fontWeight: "bold",
    fontSize: "1rem",
  },
  tableCellRow: {
    fontWeight: "bold",
    color: "#07465d",
  },
});
export default function Search() {
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState("");
  const [ob, setOb] = useState("started_at");
  const [ot, setOt] = useState("desc");
  const classes = useStyles();
  let navigate = useNavigate();
  let typingTimer = null;
  let token = localStorage.getItem("token");
  const [form] = Form.useForm();
  let { hash } = useParams();
  const handleErrorApi = UseErrorHandling();

  useEffect(() => {
    if (!token) navigate("/login");
    getList(page, hash ? hash : "", "started_at", "desc");
    /*  if (location)
             form.setFieldsValue({ "email": email }) */
    if (hash) form.setFieldsValue({ email: hash });
  }, []);

  const getList = (page, keyword, ob = "started_at", ot) => {
    setIsLoading(true);
    let data = {};
    data["token"] = token;
    data["per_page"] = PER_PAGE;
    data["ot"] = ot;
    data["page"] = page;
    data["ob"] = ob;
    if (keyword) data["hash"] = keyword;
    createData("scan/search",data)
      .then((getLastScanListResult) => {
        if (!getLastScanListResult?.success) {
          handleErrorApi(getLastScanListResult);
          setIsLoading(false);
          return;
        }
        const {total,scans} = getLastScanListResult.data
        console.log("total",getLastScanListResult.data)
        setIsLoading(false);
        setTotal(total);
        setTableData(scans);
        renderData(scans);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error?.response) {
          handleErrorApi(error?.response.data); 
        }
      });
   
  };

  const renderData = async (scanList) => {
    for (const scanData of scanList) {
        createData(`scan/result/${scanData.guid}`, { token: token })
      .then((getScanResult) => {
        if (!getScanResult?.success) {
          handleErrorApi(getScanResult);
          return;
        }
        setTableData((prevState) => {
            return prevState.map((el) => {
              if (el.guid === scanData.guid) {
                return {
                  ...el,
                  md5: getScanResult.data.md5,
                  result: getScanResult.data,
                };
              } else {
                return el;
              }
            });
          });
      })
      .catch((error) => {
        if (error?.response) {
          handleErrorApi(error?.response.data); 
        }
      });
    //   await getScanResult(scanData.guid, { token: token }).then((res) => {
    //     if (res.success !== undefined) navigate("/login");
    //     if (res.data.success) {
    //       setTableData((prevState) => {
    //         return prevState.map((el) => {
    //           if (el.guid === scanData.guid) {
    //             return {
    //               ...el,
    //               md5: res.data.data.md5,
    //               result: res.data.data,
    //             };
    //           } else {
    //             return el;
    //           }
    //         });
    //       });
    //     }
    //   });
    }
  };

  const searchUserOnchange = (e) => {
    let value = e.target.value;
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      setKeyword(value);
      getList(page, value, ob, ot);
    }, 1000);
  };

  const pageinationOnChangeHandler = (e, v) => {
    setPage(v);
    getList(v, keyword, ob, ot);
  };

  const sortHandler = (sort) => {
    if (ot === "asc") setOt("desc");
    else setOt("asc");

    getList(page, keyword, sort, ot === "asc" ? "desc" : "asc");
  };

  const goToDetailsHandler = (md5, guid) => {
    if (md5 !== undefined) navigate(`/results?hash=${md5}&scanid=${guid}`);
    else navigate(`/results?scanid=${guid}`);
  };

  const timeHandler = (time) => {
    if (!lang || lang === "en")
      return moment.unix(time).format("HH:mm YYYY-MM-DD").split(" ");
    else return moment.unix(time).format("HH:mm jYYYY-jMM-jDD").split(" ");
  };

  const checkResultStatus = (scan_data) => {
    if (scan_data.result === undefined)
      return (
        <span className="2xl:mr-20 xl:mr-24">
          {getStringsBasedLang("underـreview")}
        </span>
      );
    else if (!scan_data.result.finished_at)
      return (
        <span className="2xl:mr-20 xl:mr-24">
          {getStringsBasedLang("scan_title")}
        </span>
      );
    else if (scan_data.result)
      return (
        <div
          className={`absolute -top-4 ${
            lang === "fa"
              ? "left-24 -right-[100px] lg:-right-[140px] xl:-right-[105px] md:-right-[150px] sm:-right-[150px] xs:-right-[150px]"
              : "-left-24 lg:-left-32 md:-left-36 sm:-left-36 xs:-left-36"
          } w-full`}
        >
          <CustomGauge data={scan_data.result} />
        </div>
      );
  };

  const columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      align: "center",
      className: "text-xs",
      responsive: ["sm"],
      render: (value, row, index) => (
        <span className={`${!lang || lang === "en" ? "englishIranSans" : ""}`}>
          {index + 1}
        </span>
      ),
    },
    {
      title: (
        <div className="flex justify-center items-center">
          <span className="englishIranSans">
            {getStringsBasedLang("fileHash")}
          </span>
        </div>
      ),
      dataIndex: "md5",
      key: "md5",
      align: "center",
      className: "primary_text_color",
      render: (value, row, index) => (
        <span dir="ltr" className="englishIranSans">
          {row.md5 !== undefined ? row.md5 : "-"}
        </span>
      ),
    },
    {
      title: (
        <div
          className="flex justify-center items-center cursor-pointer"
          onClick={() => sortHandler("started_at")}
        >
          <span>{getStringsBasedLang("dateTimeScan")}</span>
          {
            <img
              className={`w-5 cursor-pointer ${
                !lang || lang === "en" ? "ml-2" : "mr-3"
              }`}
              src={require(`../../assets/icons/${ot}.svg`)}
              alt="Sort"
            />
          }
        </div>
      ),
      dataIndex: "started_at",
      key: "started_at",
      align: "center",
      className: "text-xs",
      render: (value, row, index) => (
        <div className={`${!lang || lang === "en" ? "englishIranSans" : ""}`}>
          <span>{timeHandler(row.started_at)[1].replace(/-/g, "/")}</span>
          <span
            className={`ml-2 ${
              !lang || lang === "en" ? "englishIranSans" : ""
            }`}
          >
            {timeHandler(row.started_at)[0]}
          </span>
        </div>
      ),
    },
    {
      title: (
        <div className="flex justify-center items-center">
          <span>{getStringsBasedLang("riskLevel")}</span>
        </div>
      ),
      dataIndex: "result",
      key: "result",
      align: "center",
      render: (value, row, index) => (
        <div className="w-[300px] relative text-center">
          {checkResultStatus(row)}
        </div>
      ),
    },
    {
      title: (
        <div
          className="flex justify-center items-center" /* onClick={() => sortHandler('files_count')} */
        >
          <span>{getStringsBasedLang("details")}</span>
        </div>
      ),
      dataIndex: "files_count",
      key: "files_count",
      align: "center",
      className: "text-xs",
      render: (value, row, index) => (
        <Button
          type="primary"
          onClick={() => goToDetailsHandler(row.md5, row.guid)}
        >
          {getStringsBasedLang("view")}
        </Button>
      ),
    },
  ];

  return (
    <Layout>
      <Container>
        <div className="container mx-auto md:px-16 mt-56 mb-40">
          <main className="p-5 bg-white rounded-lg">
            <div className="gradient_blue_background" />
            <Form
              name="login-form"
              layout="vertical"
              form={form}
              className="mt-8"
            >
              <Form.Item name="email" rules={[{ required: false }]}>
                <Input
                  className="mb-5 primary_text_color font-semibold englishIranSans"
                  placeholder={getStringsBasedLang("searchBaseHash")}
                  onChange={searchUserOnchange}
                  prefix={<SearchOutlined />}
                />
              </Form.Item>
            </Form>
            <Table
              columns={columns}
              dataSource={tableData}
              rowClassName="text-sm md:text-base primary_text_color font-bold"
              size="large"
              className=""
              pagination={false}
              showSorterTooltip={true}
              bordered
              loading={isLoading}
              scroll={{ x: "sm" }}
              /*                     onChange={handleTableChange}
               */
            />
            <div dir="ltr" className="flex justify-center mt-5">
              {total / PER_PAGE > 1 && (
                <div dir="">
                  <Pagination
                    count={
                      total / PER_PAGE > Math.floor(total / PER_PAGE)
                        ? Math.floor(total / PER_PAGE) + 1
                        : total / PER_PAGE
                    }
                    page={page}
                    className={classes.root}
                    onChange={pageinationOnChangeHandler}
                  />
                </div>
              )}
            </div>
          </main>
        </div>
      </Container>
    </Layout>
  );
}
